import { read, utils } from 'xlsx';
import { sanitizeFilterExpression } from '../../../../../../helpers';

const parseContent = (input: string | string[]): { validItems: string[]; invalidLines: string[] } => {
  const validItemsSet = new Set<string>();
  const invalidLines: string[] = [];
  const lines = Array.isArray(input) ? input : input.split(/\r?\n/);

  for (const line of lines) {
    const value = line.trim().replace(/^["']|["']$/g, '');
    if (!value) continue;

    const sanitized = sanitizeFilterExpression(value);
    if (!sanitized) {
      invalidLines.push(value);
    } else {
      validItemsSet.add(sanitized);
    }
  }

  return { validItems: Array.from(validItemsSet), invalidLines };
};

const extractFromFile = (content: string | ArrayBuffer): string[] => {
  const type = content instanceof ArrayBuffer ? 'array' : 'string';
  const workbook = read(content, { type, cellText: true, raw: false });
  const lines: string[] = [];
  for (const sheetName of workbook.SheetNames) {
    const rows = utils.sheet_to_json<string[]>(workbook.Sheets[sheetName], { header: 1, raw: false, defval: '' });
    for (const row of rows) {
      const firstNonEmpty = row.find((c) => c?.toString().trim())?.toString() ?? '';
      if (firstNonEmpty) lines.push(firstNonEmpty);
    }
  }
  return lines;
};

export const parseRawInput = (content: string | ArrayBuffer, fileUpload = false) => {
  if (fileUpload && content instanceof ArrayBuffer) {
    return parseContent(extractFromFile(content));
  }
  return parseContent(content as string);
};
